<template lang="pug">
  .mx-2(:class="{ 'mx-16': $vuetify.breakpoint.mdAndUp }")
    .d-flex.justify-center.py-16(v-if="loading")
      v-progress-circular(indeterminate color="primary")
    v-alert.mt-8(v-else-if="loadError" type="error" outlined) 文章暫時無法載入，請稍後再試。
    v-alert.mt-8(v-else-if="!article" type="info" outlined) 找不到這篇文章，可能尚未發佈或已被移除。
    template(v-else)
      .article-media
        .article-video(v-if="videoEmbed")
          iframe(
            :src="videoEmbed.src"
            :title="videoEmbed.title"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="eager"
            referrerpolicy="strict-origin-when-cross-origin"
          )
        v-img(v-else :src="articleImageUrl(article)" :alt="article.title" eager max-height="620" contain class="grey lighten-4")
      h1.mt-6.mx-2.text-h5 {{ article.title }}
      .mt-2.mx-4
        .d-flex.flex-wrap.align-center.text-subtitle-1.grey--text
          template(v-if="article.author_name")
            v-icon(size="14") mdi-account-outline
            span.ml-1.mr-3 作者：{{ article.author_name }}
          v-icon(size="14") mdi-calendar-blank-outline
          span.ml-1 發布：
          time(:datetime="article.post_date") {{ article.post_date }}
          template(v-if="updatedDate")
            v-icon.ml-3(size="14") mdi-update
            span.ml-1 更新：
            time(:datetime="article.updated_at") {{ updatedDate }}
          v-icon.ml-3(size="14") mdi-eye
          span.ml-1 {{ article.read_num }}{{ $t('News_4') }}
      .mt-6.mx-2.text-body-1.article-content {{ article.content }}
      .mt-6.mx-2(v-if="safeExternalVideoUrl && !videoEmbed")
        v-btn(:href="safeExternalVideoUrl" target="_blank" rel="noopener noreferrer" outlined color="primary")
          v-icon(left) mdi-play-circle-outline
          | 觀看影片
      .mt-3.mx-2.text-caption.grey--text(v-else-if="videoEmbed")
        | 如果播放器無法顯示，可能是影片並非公開內容。
        a.ml-1(:href="videoEmbed.originalUrl" target="_blank" rel="noopener noreferrer") 在新分頁開啟
      .mt-10.mb-16.mx-2
        v-chip.grey--text.text--darken-1.mr-2(v-for="tag in article.tags" :key="tag") {{ tag }}
</template>

<script>
import {
  articleImageUrl,
  articleVideoEmbed,
  fetchArticle,
  safeVideoUrl,
} from "@/services/articles";
import { applyArticleSeo, applyRouteSeo } from "@/services/seo";
import moment from "moment";

export default {
  name: "NewsInfo",

  data() {
    return {
      article: null,
      loading: true,
      loadError: false,
      loadSequence: 0,
    };
  },

  computed: {
    videoEmbed() {
      return this.article ? articleVideoEmbed(this.article.video_url) : null;
    },
    safeExternalVideoUrl() {
      return this.article ? safeVideoUrl(this.article.video_url) : "";
    },
    updatedDate() {
      if (!this.article || !this.article.updated_at) return "";
      const value = moment(this.article.updated_at);
      return value.isValid() ? value.format("YYYY-MM-DD") : "";
    },
  },

  methods: {
    articleImageUrl,
    async loadArticle() {
      const sequence = ++this.loadSequence;
      const uid = this.$route.params.uid;
      const isCurrent = () => sequence === this.loadSequence &&
        this.$route.name === "NewsInfo" && this.$route.params.uid === uid;
      this.loading = true;
      this.article = null;
      this.loadError = false;
      try {
        const article = await fetchArticle(uid);
        if (!isCurrent()) return;
        this.article = article;
        if (this.article) applyArticleSeo(this.article);
        else applyRouteSeo(this.$route, { noindex: true });
      } catch (error) {
        if (!isCurrent()) return;
        this.loadError = true;
        applyRouteSeo(this.$route, { noindex: true });
      } finally {
        if (isCurrent()) this.loading = false;
      }
    },
  },

  watch: {
    "$route.params.uid": "loadArticle",
  },

  mounted() {
    this.loadArticle();
  },
  beforeDestroy() {
    this.loadSequence += 1;
  },
};
</script>

<style lang="sass" scoped>
.article-media
  width: 100%

.article-video
  position: relative
  width: 100%
  padding-top: 56.25%
  overflow: hidden
  background: #000

  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    border: 0

.article-content
  white-space: pre-line
  line-height: 1.9
</style>
